module.exports = __webpack_public_path__ + "images/tallink/city-default.png";